// users.weight_kg는 REAL(float4)이고 서버는 float64로 읽어 보내, 72.3으로 저장한 몸무게가 72.30000305175781로 온다(출시 전부터).
// float4로 같은 값이 되는 가장 짧은 십진수로 되돌린다(72.30000305175781 → 72.3). 숫자가 아니거나 0 이하(미입력)면 0.
// 회원 상세(ProfileView, 출시 최종 확인 6차)와 실시간 심박의 게스트 추가·게스트 정보 창(앱 전체 리뷰 1차)이 같이 쓴다.
export function float4Number(v) {
  const n = Number(v);
  if (!Number.isFinite(n) || n <= 0) return 0;
  const f = Math.fround(n);
  for (let p = 1; p <= 9; p++) {
    const c = Number(n.toPrecision(p));
    if (Math.fround(c) === f) return c;
  }
  return n;
}
